<template>
  <div class="page-reviews-admin" v-if="currentUser">
    <div class="page-header">
      <h1>Oceny serwisu</h1>
      <button class="btn-outline" @click="getReviews">Odśwież</button>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Edycja kafelków opinii</h2>
        <p class="section-subtitle">Wybierz kafelek i zaktualizuj treść oraz ocenę.</p>
      </div>

      <div class="selector-row">
        <label>Wybierz opinię</label>
        <DropdownVue
            :items="cards"
            placeholder="kafelek"
            id="serviceReviewsDropdown"
            @setChecked="(e) => setCurrentReview(e)"
            :border="true"
        />
      </div>

      <form class="review-form" v-if="currentReview" @submit.prevent="editReview">
        <div class="form-group">
          <label for="title">Tytuł</label>
          <input
              type="text"
              id="title"
              name="title"
              placeholder="tytuł"
              maxlength="50"
              minlength="10"
              v-model="currentReview.title"
              required
          >
        </div>

        <div class="form-group">
          <label for="content">Treść opinii</label>
          <textarea
              id="content"
              name="content"
              cols="30"
              rows="10"
              maxlength="300"
              minlength="10"
              v-model="currentReview.content"
              required
          ></textarea>
        </div>

        <div class="form-group rate-group">
          <label for="rate">Ocena</label>
          <div class="rate-input-wrap">
            <input type="number" name="rate" id="rate" max="6" min="1" v-model="currentReview.rate">
            <span>/ 6</span>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-primary">Zatwierdź</button>
        </div>
      </form>

      <div v-else class="empty-state">
        <p>Ładowanie opinii...</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import DropdownVue from '@/components/Dropdown.vue';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'PageReviews',
  components: {
    DropdownVue,
  },
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      cards: [
        { name: 'kafelek 1', value: '1' },
        { name: 'kafelek 2', value: '2' },
        { name: 'kafelek 3', value: '3' },
        { name: 'kafelek 4', value: '4' },
      ],
      card: '',
      currentReview: null,
      reviews: [],
    };
  },
  props: ['isVisible'],
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
    this.getReviews();
  },
  methods: {
    getReviews() {
      axios.get('/CmsAll').then(res => {
        this.reviews = res.data.filter(item => item.title.includes('Opinia'));
        this.currentReview = {
          title: this.reviews[0].content.split('|')[0],
          content: this.reviews[0].content.split('|')[2],
          rate: this.reviews[0].content.split('|')[1],
          id: this.reviews[0].id,
          independentTitle: this.reviews[0].title,
        };
      }).catch(() => {});
    },
    setCurrentReview(e) {
      if (e !== 'placeholder') {
        this.currentReview = {
          title: this.reviews.filter(rev => rev.title.includes(e))[0]?.content?.split('|')[0],
          content: this.reviews.filter(rev => rev.title.includes(e))[0]?.content?.split('|')[2],
          rate: this.reviews.filter(rev => rev.title.includes(e))[0]?.content?.split('|')[1],
          id: this.reviews.filter(rev => rev.title.includes(e))[0]?.id,
          independentTitle: this.reviews.filter(rev => rev.title.includes(e))[0]?.title,
        };
      }
    },
    editReview() {
      if (this.currentReview) {
        if (this.currentReview.title.includes('|') || this.currentReview.content.includes('|')) {
          this.appStore.setIsAlert('Żadne z pól nie może zawierać znaku: |');
        } else {
          axios.post('/Cms', {
            id: this.currentReview.id,
            title: this.currentReview.title,
            content: `${this.currentReview.title}|${this.currentReview.rate}|${this.currentReview.content}`,
          }, authHeader()).then(res => {
            if (String(res.status).charAt(0) == '2') {
              this.reviews.filter(item => item.id == this.currentReview.id)[0].content = `${this.currentReview.title}|${this.currentReview.rate}|${this.currentReview.content}`;
              this.appStore.setIsSuccess(`Zaktualizowano kafelek ${this.currentReview.title.slice(7)}`);
            }
          }).catch(() => {});
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page-reviews-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 18px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-subtitle {
  margin: 0;
  color: #6b7280;
  font-size: 1.4rem;
}

.selector-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 18px;
}

.selector-row label {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
}

.review-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
}

.form-group input,
.form-group textarea {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  color: #1f2937;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
  width: 100%;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.12);
}

.form-group textarea {
  min-height: 180px;
  resize: vertical;
}

.rate-group .rate-input-wrap {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.rate-group .rate-input-wrap input {
  width: 120px;
}

.rate-group .rate-input-wrap span {
  color: #6b7280;
  font-size: 1.4rem;
  font-weight: 600;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  border-top: 1px solid #e5e7eb;
}

.empty-state {
  text-align: center;
  padding: 28px;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.4rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

@media (max-width: 480px) {
  .page-reviews-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .btn-primary,
  .btn-outline {
    width: 100%;
    text-align: center;
  }

  .form-actions {
    justify-content: stretch;
  }
}
</style>